/**
 * Format date for display in tables
 * Handles ISO strings, Date objects, and null/undefined
 */
export const formatDate = (date) => {
  if (!date) return '—';
  const d = typeof date === 'string' || date instanceof Date ? new Date(date) : date;
  if (isNaN(d.getTime())) return '—';
  return d.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric'
  });
};
